import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const ViewAgendaIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"view_agenda"} ref={ref}/>
});

ViewAgendaIcon.displayName = "ViewAgendaIcon";
